import React from 'react';

type Props = {
  id: string;
  eyebrow: string;
  title: string;
  description: string;
  count: number;
  accent: 'blue' | 'amber' | 'violet' | 'green';
  meta?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

const MarketSection: React.FC<Props> = ({
  id,
  eyebrow,
  title,
  description,
  count,
  accent,
  meta,
  children,
  className = '',
}) => (
  <section
    id={id}
    className={`markets-v2-section markets-v2-section--${accent} ${className}`}
    aria-labelledby={`${id}-title`}
  >
    <header className="markets-v2-section__head">
      <div className="markets-v2-section__identity">
        <span className="markets-v2-section__eyebrow">{eyebrow}</span>
        <div className="markets-v2-section__title-line">
          <h2 id={`${id}-title`}>{title}</h2>
          <span className="markets-v2-section__count">{count}</span>
        </div>
        <p>{description}</p>
      </div>
      {meta && <div className="markets-v2-section__meta">{meta}</div>}
    </header>
    <div className="markets-v2-section__body">{children}</div>
  </section>
);

export default MarketSection;
